import React, { useCallback, useEffect, useState } from 'react';
import styles from './employees-card.module.scss';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { Alert, DefaultButton, EmployeeMiniCard, SearchInput } from 'shared/ui';
import { businessStore, UserRoleEnum, userStore } from 'entities/index';
import { observer } from 'mobx-react';

interface IEmployeesCardProps {
  pointId: string;
}
export const EmployeesCard: React.FC<IEmployeesCardProps> = observer(
  ({ pointId }) => {
    const [inputValue, setInputValue] = useState('');
    const [showLimitAlert, setShowLimitAlert] = useState(false);

    const normalizedSearch = inputValue.toLowerCase().trim();

    const matchesSearch = (employee: {
      fio?: string;
      phone?: string;
      email?: string;
    }): boolean => {
      if (!normalizedSearch) return true;
      return (
        !!employee.fio?.toLowerCase().includes(normalizedSearch) ||
        !!employee.phone?.toLowerCase().includes(normalizedSearch) ||
        !!employee.email?.toLowerCase().includes(normalizedSearch)
      );
    };
    const navigate = useNavigate();

    useEffect(() => {
      businessStore.initEmployeesWidgetData(pointId);
    }, []);

    const navigateToCreateEmployees = () => {
      if (userStore.employeesCount >= userStore.licEmployeeLimit) {
        setShowLimitAlert(true);
        return;
      }
      const path = AppLinks.CreateEmployeeLink.replace(':id', pointId);
      navigate(path);
    };

    const closeLimitAlert = useCallback(() => setShowLimitAlert(false), []);

    const navigateToEmployeeSchedules = () => {
      const path = AppLinks.PointEmployeeSchedulesLink.replace(':id', pointId);
      navigate(path);
    };

    const canManageEmployees = [
      UserRoleEnum.OWNER,
      UserRoleEnum.ADMINISTRATOR,
      UserRoleEnum.MANAGER,
    ].includes(userStore.role);

    return (
      <div className={styles.business_employees__container}>
        <div className={styles.container__search}>
          <SearchInput
            value={inputValue}
            placeholder="Поиск по сотрудникам"
            onChange={setInputValue}
          />
        </div>
        <div className={styles.container__content}>
          <div className={styles.content}>
            {businessStore.employeesWidgetData
              ?.filter(matchesSearch)
              .map((employee, index) => (
                <React.Fragment key={employee.id}>
                  <EmployeeMiniCard employeeInfo={employee} key={index} />
                </React.Fragment>
              ))}
          </div>
        </div>
        {canManageEmployees ? (
          <div className={styles.container__button}>
            <div
              className={styles.button__wrapper}
              onClick={navigateToEmployeeSchedules}
            >
              <DefaultButton buttonText="Графики работы" />
            </div>
            <div
              className={styles.button__wrapper}
              onClick={navigateToCreateEmployees}
            >
              <DefaultButton buttonText="Создать сотрудника" />
            </div>
          </div>
        ) : null}

        {showLimitAlert && (
          <Alert
            type="error"
            message="Вы достигли максимального количества сотрудников, расширьте подписку"
            onClose={closeLimitAlert}
          />
        )}
      </div>
    );
  }
);
